import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from 'vue-router';
import useUserStore from '@/store/modules/user';
import CONSTANTS from '@/utils/constants';
import util from '@/utils';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/layout'),
    async beforeEnter(to, from, next) {
      const token = util.getLocalStorage(CONSTANTS.TOKEN);
      if (token) {
        const userStore = useUserStore();
        if (userStore.menus.length) {
          if (to.fullPath === from.fullPath) {
            next(userStore.menus[0].path);
          } else {
            next();
          }
        } else {
          await userStore.getUserInfo();
          next(userStore.menus[0].path);
        }
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/pages/loading'),
    hidden: true,
    async beforeEnter(to, from, next) {
      const token = util.getLocalStorage(CONSTANTS.TOKEN);
      if (token) {
        const userStore = useUserStore();
        if (userStore.menus.length) {
          next(userStore.menus[0].path);
        } else {
          await userStore.getUserInfo();
          if (userStore.menus.length) {
            if (from.path === to.path) {
              next(userStore.menus[0].path);
            } else {
              next(to.fullPath);
            }
          } else {
            userStore.clearStorage();
            next('/login');
          }
        }
      } else {
        next('/login');
      }
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/404'),
    hidden: true,
  },
];

export const permissionsRouteMap = {
  // 小程序配置
  appConfig: {
    name: 'appConfig',
    path: '/miniapp/banner',
    icon: 'icon-xiaochengxu',
    meta: { title: '小程序配置' },
    component: () => import('@/pages/appConfig'),
    children: [
      {
        name: 'banner',
        path: '/miniapp/banner',
        icon: 'icon-zizhanghao',
        meta: { title: '轮播图管理' },
        component: () => import('@/pages/appConfig/banner'),
      },
    ],
  },
  // apply: {
  //   name: 'apply',
  //   path: '/apply',
  //   icon: 'icon-dingdanguanli',
  //   meta: { title: '报名管理' },
  //   component: () => import('@/pages/apply'),
  //   children: [
  //     {
  //       name: 'coursesApp',
  //       path: '/apply/courses',
  //       icon: 'icon-zizhanghao',
  //       meta: { title: '线下课程报名' },
  //       component: () => import('@/pages/apply/courses'),
  //     },
  //     {
  //       name: 'activitiesApp',
  //       path: '/apply/activities',
  //       icon: 'icon-zizhanghao',
  //       meta: { title: '活动报名' },
  //       component: () => import('@/pages/apply/activities'),
  //     },
  //   ],
  // },

  order: {
    name: 'orderList',
    path: '/order/signUpOrders',
    icon: 'icon-dingdanguanli',
    meta: { title: '订单管理' },
    component: () => import('@/pages/order'),
    children: [
      {
        name: 'buyOrders',
        path: '/order/buyOrders',
        icon: 'icon-zizhanghao',
        meta: { title: '活动订单管理' },
        component: () => import('@/pages/order/buyOrders'),
      },
      {
        name: 'signUpOrders',
        path: '/order/signUpOrders',
        icon: 'icon-zizhanghao',
        meta: { title: '公益课报名' },
        component: () => import('@/pages/order/signUpOrders'),
      }, {
        name: 'vipCourseSignUp',
        path: '/order/vipCourseSignUp',
        icon: 'icon-zizhanghao',
        meta: { title: 'vip课程报名' },
        component: () => import('@/pages/order/vipCourseSignUp'),
      },
      {
        name: 'rechargeList',
        path: '/order/rechargeList',
        icon: 'icon-zizhanghao',
        meta: { title: '充值列表' },
        component: () => import('@/pages/order/rechargeList'),
      },
    ]
  },
  course: {
    name: 'course',
    path: '/course/welfareCourse',
    icon: 'icon-shangpinguanli',
    meta: { title: '课程管理' },
    component: () => import('@/pages/course'),
    children: [
      {
        name: 'welfareCourse',
        path: '/course/welfareCourse',
        icon: 'icon-zizhanghao',
        meta: { title: '公益课管理' },
        component: () => import('@/pages/course/welfareCourse'),
      },
      {
        name: 'vipCourse',
        path: '/course/vipCourse',
        icon: 'icon-zizhanghao',
        meta: { title: 'vip课程管理' },
        component: () => import('@/pages/course/vipCourse'),
      },

      {
        name: 'activities',
        path: '/course/activities',
        icon: 'icon-zizhanghao',
        meta: { title: '活动管理' },
        component: () => import('@/pages/course/activities'),
      },
    ],
  },
  // 会员管理
  member: {
    name: 'member',
    path: '/member/list',
    icon: 'icon-aixinjuanzeng',
    meta: { title: '会员管理' },
    component: () => import('@/pages/member'),
    children: [
      {
        name: 'member',
        path: '/member/list',
        meta: { title: '会员管理' },
        component: () => import('@/pages/member/list'),
      },
      {
        name: 'pointChange',
        path: '/member/point/:id',
        icon: 'icon-zizhanghao',
        meta: { title: '积分变化' },
        component: () => import('@/pages/member/pointChange'),
        menuHide: true,
      },
      {
        name: 'hisRecommend',
        path: '/member/recommend/:id',
        icon: 'icon-zizhanghao',
        meta: { title: '推荐列表' },
        component: () => import('@/pages/member/hisRecommend'),
        menuHide: true,
      },
    ],
  },
  // 账号管理
  account: {
    name: 'account',
    path: '/account',
    icon: 'icon-zizhanghaoguanli',
    meta: { title: '子账号管理' },
    component: () => import('@/pages/account'),
  },
};

const router = createRouter({
  history:
    process.env.NODE_ENV === 'production'
      ? createWebHistory()
      : createWebHashHistory(),
  routes: routes,
});

// 动态添加路由
export const addRoutes = permissions => {
  permissions.forEach(key => {
    const route = permissionsRouteMap[key];
    if (route) router.addRoute('home', route);
  });
};

export default router;
